import { useState, useEffect } from 'react';
import { formEventV2 } from '../service/formEventV2';

/**
 * 根据弹窗步骤与 settings 派生 banner/floatBanner 显示状态及上报
 */
export function useBannerState(options: {
  settings: any;
  type: string;
  tanChuangStep: string;
  show: boolean;
  /** 转盘等获得的券码，用于 Banner 展示时回填 */
  couponCode: string;
  triggerEventType: number;
  id: string;
  name: string;
}) {
  const { settings, type, tanChuangStep, show, couponCode, triggerEventType, id, name } = options;
  /** 是否展示底部 Banner（弹窗结束或转盘有券且弹窗已关） */
  const [bannerShow, setBannerShow] = useState(false);
  /** 是否展示浮条（部分 triggerEventType 且弹窗结束且配置开启） */
  const [floatBannerShow, setFloatBannerShow] = useState(false);
  /** 传给 Banner/FloatBanner 的配置（含 bannerCouponCode 等） */
  const [bannerInfo, setBannerInfo] = useState<any>({});

  /** 弹窗结束或转盘有券且弹窗关闭时展示 Banner，并清理其他 cartx-banner-ref */
  useEffect(() => {
    if (settings?.banner?.bannerShow && (tanChuangStep === 'end' || (type === 'WheelOfFortune' && !!couponCode)) && !show) {
      setBannerShow(true);
      if (!settings?.banner?.bannerCouponCode && !!couponCode) {
        setBannerInfo({ ...settings.banner, bannerCouponCode: couponCode });
      } else {
        setBannerInfo(settings.banner);
      }
      /** 移除页面上其他已挂载的 Banner DOM，避免重复 */
      const cartxBannerRef = document.querySelectorAll('.cartx-banner-ref');
      cartxBannerRef.forEach((item) => item.remove());
    }
  // 仅在这些关键状态变化时重算 banner 显示
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings?.banner?.bannerShow, tanChuangStep, show]);

  /** 弹窗步骤为 end 且已关闭时，部分触发类型下展示浮条并更新 bannerInfo */
  useEffect(() => {
    if (tanChuangStep === 'end' && !show) {
      if ([1, 2, 3, 5, 6, 8].includes(triggerEventType)) {
        if (settings?.rules?.couponCodeShow === true && !!settings.rules.couponCodePosition) {
          if (settings.banner?.floatBannerShow !== false) setFloatBannerShow(true);
        }
        setBannerInfo(settings?.banner || {});
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tanChuangStep, show]);

  /** Banner 或浮条展示时上报 banner_ad_view */
  useEffect(() => {
    if (bannerShow || floatBannerShow) {
      formEventV2({
        event: 'banner_ad_view',
        triggerEventType,
        formId: id,
        formName: name
      }).catch(() => {});
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bannerShow, floatBannerShow]);

  return { bannerShow, setBannerShow, floatBannerShow, setFloatBannerShow, bannerInfo, setBannerInfo };
}
